import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { AllGender } from "../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller } from "react-hook-form";

function StudentRegistration_stap_2({ register, errors, control }) {
  /* Dropdown options */
  const dispatch = useDispatch();

  const genders = useSelector((state) => state.common.all_gender);

  useEffect(() => {
    dispatch(AllGender());
  }, [dispatch]);

  return (
    <>
      <h5 className="step-heading">B. Civil Status (as per Passport)</h5>
      <div className="form_holder">
        <div className="row">
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Sex </Form.Label>
              <Controller
                name="gender_id"
                control={control}
                rules={{ required: "Gender is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={genders}
                    onInputChange={(val) => {
                      dispatch(AllGender(val));
                    }}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                )}
              />
              {errors?.gender_id && (
                <Form.Text className="text-danger">
                  {errors?.gender_id?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              {" "}
              <Form.Label>Birth Country</Form.Label>
              <Form.Control
                {...register("birth_country", {
                  required: "Country is required",
                })}
                placeholder="Enter Country"
              />
              {errors.birth_country && (
                <Form.Text className="text-danger">
                  {errors.birth_country.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Birth State</Form.Label>
              <Form.Control
                {...register("birth_state", {
                  required: "State is required",
                })}
                placeholder="Enter State"
              />
              {errors.birth_state && (
                <Form.Text className="text-danger">
                  {errors.birth_state.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Birth City</Form.Label>
              <Form.Control
                {...register("birth_city", {
                  required: "City is required",
                })}
                placeholder="Enter City"
              />
              {errors.birth_city && (
                <Form.Text className="text-danger">
                  {errors.birth_city.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Nationality</Form.Label>
              <Form.Control
                {...register("nationality", {
                  required: "Nationality is required",
                })}
                placeholder="Enter Nationality"
              />
              {errors.nationality && (
                <Form.Text className="text-danger">
                  {errors.nationality.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentRegistration_stap_2;
